import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { type Task } from '@/types/Task'
import { TaskModel } from '@/models/TaskModel'

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  status: { value: null, matchMode: FilterMatchMode.EQUALS },
  assignedTo: { value: null, matchMode: FilterMatchMode.EQUALS },
  dueDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  organizationId: { value: null, matchMode: FilterMatchMode.EQUALS },
  personId: { value: null, matchMode: FilterMatchMode.EQUALS },
  vehicleId: { value: null, matchMode: FilterMatchMode.EQUALS },
  transactionId: { value: null, matchMode: FilterMatchMode.EQUALS },
}

export const defaultSort = {
  field: 'dueAt',
  order: 1,
}

// Create the task store using the base document store
export const useTaskStore = defineDocStore<Task>({
  entityName: 'task',
  collection: 'tasks',
  model: TaskModel,
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})

// Re-export types and factory for convenience
export type { Task } from '@/types/Task'
export { createTask } from '@/factories/taskFactory'
